import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../../../hooks/useAuth";
import TableLayout from "../../../../layouts/TableLayout/NewTableLayout";
import { useFetchAll } from "../../../../hooks/useFetchAll";
import {
  useGetPayoutsQuery,
  useUpdatePayoutMutation,
} from "../../../../redux/services/payouts/payoutsApi";
import { COLUMN_DEFINITIONS } from "./table.config";

const OrgPayouts = ({ organization, driver }) => {
  const { user } = useAuth();
  const params = useParams();
  const navigate = useNavigate();

  // Use useFetchAll hook with organizationId filter
  const {
    pagination: { pageIndex, pageSize, setPagination },
    queryResult: { data, isLoading, isFetching },
  } = useFetchAll({
    queryHook: useGetPayoutsQuery,
    defaultPageSize: 20,
    defaultFilters: useMemo(
      () => [{ id: "organizationId", value: params.id }],
      [params.id]
    ),
  });

  const [updatePayout] = useUpdatePayoutMutation();

  async function handleUpdate(e, setLoading) {
    try {
      const updateData = {
        id: e.row.original._id,
        data: e.data,
      };

      const res = await updatePayout(updateData).unwrap();

      toast(res.message, {
        type: res.status,
        toastId: "org-payouts-update",
      });
    } catch (error) {
      toast.error("Failed to update payout", {
        toastId: "org-payouts-update-error",
      });
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }

  function handleClick() {
    navigate(`/payouts/create`);
  }

  function handleEdit(itemId) {
    navigate(`/payouts/${itemId}`);
  }

  return (
    <div className="xl:col-span-6 col-span-8">
      <TableLayout
        id="org-payouts"
        loading={isLoading || isFetching}
        columns={COLUMN_DEFINITIONS}
        data={data?.payouts}
        pagination={data}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPaginationChange={setPagination}
        handleEdit={handleEdit}
        onUpdate={handleUpdate}
        mainAction={{ onClick: handleClick, title: "Create Payout" }}
        title="Payouts"
        hideCheckbox
        meta={{
          updateData: handleUpdate,
        }}
      />
    </div>
  );
};

export default OrgPayouts;
